/**
 * Compte « invité recherche » (.scratch/projets-scientifiques/invites-exterieurs.md, D5).
 *
 * Personne extérieure invitée sur un projet scientifique : rattachée à aucun
 * parc (`zooId: null`, registre `accessGrants/{uid}` vide). Elle n'ouvre que
 * les projets où elle est invitée et son compte, toujours en V2.
 */
import { readUserRole } from "./userRole";

export const RESEARCH_GUEST = "researchGuest";
/** Seule page d'arrivée d'un invité recherche. */
export const RESEARCH_GUEST_HOME = "/v2/research-projects";
/** Destinations V2 ouvertes à un invité recherche (clés d'accès du registre). */
export const RESEARCH_GUEST_ACCESS_KEYS = Object.freeze(["SCIENTIFIC_PROJECTS", "USER_SETTINGS", "HELP_CENTER"]);

// Adresses V2 qu'un invité recherche peut ouvrir (le reste suppose un parc).
const RESEARCH_GUEST_PATHS = [/^\/v2\/research-projects(?:\/|$)/i, /^\/v2\/account(?:\/|$)/i, /^\/v2\/assistance\/help(?:\/|$)/i];

/** L'adresse s'ouvre-t-elle pour un invité recherche ? */
export const isResearchGuestPath = (pathname) => typeof pathname === "string"
  && RESEARCH_GUEST_PATHS.some((pattern) => pattern.test(pathname));

/** Vrai pour un profil (fiche users, copie locale ou viewer V2) d'invité recherche. */
export const isResearchGuestProfile = (user) => !!user && typeof user === "object"
  && (user.accountType === RESEARCH_GUEST || readUserRole(user.userRight) === RESEARCH_GUEST);
